//
//This is the base component for views that need to process
// RestaurantChanged event
//

export default {
    inject: ['eventBus'],
    data: function() {
        return {
            action: null
        }
    },
    methods: {
        setAction(actionParam) {
            this.action = actionParam;
        },
        currentRestaurantChangedHanlder() {
            this.$store.dispatch(this.action);
        }
    },
    created() {

    },
    mounted() {
        this.eventBus.$on('currentRestaurantChangedEvent', this.currentRestaurantChangedHanlder);
    },
    destroyed() {
        this.eventBus.$off('currentRestaurantChangedEvent', this.currentRestaurantChangedHanlder); 
    }
}